import React from 'react';
import { Component } from '../../../types';
import { HorizontalTimeline } from '../../progress/HorizontalTimeline';

export interface SharedHorizontalTimelineComponentProps {
  component: Component;
  isViewerMode?: boolean;
}

export const SharedHorizontalTimelineComponent: React.FC<SharedHorizontalTimelineComponentProps> = ({
  component,
  isViewerMode = false,
}) => {
  return (
    <HorizontalTimeline
      component={component}
      isViewerMode={isViewerMode}
    />
  );
};

SharedHorizontalTimelineComponent.displayName = 'SharedHorizontalTimelineComponent';
